// The browser download link cannot send API headers. Reuse only a media token
// already issued for this post, never a token from an image/CDN URL or another post.
export function answerImageDownloadUrl(
    apiBaseUrl: string | undefined,
    answerId: string,
    mediaUrls: Array<string | null | undefined>,
): string {
    const path = `/api/v1/answers/${encodeURIComponent(answerId)}`
    const downloadUrl = `${apiBaseUrl?.replace(/\/$/, '') || ''}${path}/download_image`
    for (const mediaUrl of mediaUrls) {
        if (!mediaUrl) continue
        try {
            const parsed = new URL(mediaUrl, 'https://treechat.invalid')
            if (parsed.pathname !== `${path}/media`) continue
            const token = parsed.searchParams.get('vtoken')
            if (token) return `${downloadUrl}?vtoken=${encodeURIComponent(token)}`
        } catch {
            // Legacy image URLs may be absent or malformed; use authenticated fetch.
        }
    }
    return downloadUrl
}
